import React from 'react';

const Alert = (props) => {
  return (
    props.alert
    &&
    <>
    <div className={`alert alert-${props.alert.type} alert-dismissible fade show container mt-2 mx-2 px-2`} role="alert">
    <strong>{props.alert.msgStatus}!!!</strong> {props.alert.mainMsg}...
    <div className={`loadBar ${props.alert.type==="success"?"bg-darkGreen":"bg-darkRed"} mt-2`}></div>
    </div>
    </>
  )
}

export default Alert